import Enum from './Enum.js';

export default class TemplateType extends Enum {
    static get entries() {
        return {
            email: 'email',
            notification: 'notification',
            sms: 'sms',
        };
    }

    static get EMAIL() {
        return this.entries.email;
    }

    static get NOTIFICATION() {
        return this.entries.notification;
    }

    static get SMS() {
        return this.entries.sms;
    }

    static get translationGroup() {
        return 'templates';
    }
}
